<template>
<div class="fc-page mg-page mg-classroom_list"><nav aria-label="面包屑"><v-breadcrumbs :items="breadcrumbs" divider="/" class="mg-breadcrumb"/></nav><header class="fc-heading"><div class="fc-child-heading"><h1>教室管理</h1><p>管理教学空间，维护教室资料与可用状态</p></div><div class="mg-heading-actions"><v-btn  @click="showAddDialog" color="#d9363e" depressed class="mg-create">添加教室</v-btn></div></header><section class="fc-filters" aria-label="教室管理筛选"><div class="fc-filter-heading"><h3>筛选条件</h3><span>按条件查找需要的记录</span></div><form @submit.prevent="getTableDataList"><div class="fc-filter-grid"><div class="fc-filter-cell"><v-text-field clearable dense label="教室名称" outlined v-model="query.roomName" color="#d9363e" aria-label="教室名称">
							</v-text-field></div>
<div class="fc-filter-cell"><v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
								transition="scale-transition" offset-y
								min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="query.start" label="创建开始日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined color="#d9363e" aria-label="创建开始日期"></v-text-field>
								</template>
								<v-date-picker v-model="query.start" @input="menu1=false" no-title scrollable locale="zh-cn" color="#d9363e">
								</v-date-picker>
							</v-menu></div>
<div class="fc-filter-cell"><v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
								transition="scale-transition" offset-y min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="query.end" label="创建结束日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined color="#d9363e" aria-label="创建结束日期"></v-text-field>
								</template>
								<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn" color="#d9363e">
								</v-date-picker>
							</v-menu></div></div><div class="fc-filter-bottom"><span>设置条件后点击查询</span><v-btn type="submit" color="#d9363e" dark depressed class="mg-query"><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></div></form></section><section class="fc-records" aria-label="教室列表"><div class="fc-list-heading"><h3>教室列表</h3><span class="fc-count">共 <strong>{{data.total}}</strong> 条</span></div><v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="fc-table mg-table fc-has-actions"
			disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......" :mobile-breakpoint="0" no-data-text="暂无符合条件的记录">

			<template v-slot:item.status="{item}">
				{{ statusName(item.status) }}
			</template>

			<template v-slot:item.action="{item}">
				<v-btn @click.stop="showUpdate(item)" color="#d9363e" small depressed>修改</v-btn>
				<v-btn @click.stop="frozenClassroom(item)" :disabled="item.status !== '1'" color="#d9363e" class="ml-3" small depressed>作废</v-btn>
				<v-btn @click.stop="freeClassroom(item)" :disabled="item.status === '1'" color="#d9363e" class="ml-3" small depressed>启用</v-btn>
			</template>

		</v-data-table><div class="fc-pagination"><div class="fc-page-size"><v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
						outlined v-model="query.size" color="#d9363e" aria-label="每页数量" /><span>条 / 页</span><span class="fc-total">共 {{data.total}} 条</span></div><div v-if="Math.ceil(data.total/query.size)>0" class="mg-pagination"><v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
						:total-visible="5" v-model="query.page" color="#d9363e" /></div></div></section><v-dialog title="修改教室" v-model="update.dialog" max-width="600" persistent scrollable>
		<v-card class="fc-dialog-card mg-dialog">
			<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-book-open-page-variant-outline</v-icon></span><div class="mg-dialog-title"><h2>修改教室信息</h2><p>完善信息后保存修改</p></div><v-spacer/><v-btn icon aria-label="关闭修改教室" @click="update.dialog=false"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>
			<v-card-text class="fc-dialog-body">
				<v-row dense>
					<v-col cols="12">
						<v-select :items="selectShopList" v-model="update.classroom.shopId"
						item-text="shopName" item-value="id" label="校区" dense outlined color="#d9363e" aria-label="校区"></v-select>
					</v-col>

					<v-col cols="12">
						<v-text-field label="教室名称" v-model="update.classroom.roomName" dense outlined color="#d9363e" aria-label="教室名称"></v-text-field>
					</v-col>


				</v-row>
			</v-card-text>
			<v-card-actions class="fc-dialog-actions">
				<v-spacer></v-spacer>
				<v-btn @click="update.dialog=false" depressed>取消</v-btn>
				<v-btn @click="submitUpdateClassroom" color="#d9363e" depressed class="fc-confirm">确定</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
<roomCreate :show="add.dialog" @cancel="add.dialog=false" @success="createRoomSuccess"></roomCreate></div>
</template>

<script>
	import roomCreate from "../../../components/room_create.vue"
	import utils from "../../../config/utils"
	export default {
		name: "classroom-list",
		components:{roomCreate},
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '系统管理',
						disabled: true
					},
					{
						text: '教室管理',
						disabled: true
					},
				],
				shopId:"",
				data: {
					total: 0,
					headers: [
						{
							text: '校区',
							value: 'shopName',
							sortable: false
						},
						{
							text: '教室名称',
							value: 'roomName',
							sortable: false
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						{
							text: '创建时间',
							value: 'createAt',
							sortable: false
						},
						{
							text: '操作',
							align: 'center',
							value: 'action',
							sortable: false
						},
					],
					list: [],
				},
				selectShopList:[], //选择门店数据
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
					roomName: "",
					shopId: ""
				},
				add: {
					dialog: false,
				},
				update: {
					dialog: false,
					classroom: {
						id:"",
						roomName: "",
						shopId:"",
					}
				},
			}
		},
		created() {
			// 获取门店列表
			this.shopId = utils.getCurrentShopId();
			this.getTableDataList();
		},
		methods: {
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			showAddDialog() {
				this.add.dialog = true;
			},
			createRoomSuccess(){
				this.add.dialog= false;
				this.getTableDataList();
			},
			getTableDataList() {
				const that = this;
				this.query.loading = true;


				let url = `/edu/classroom/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.roomName) {
					url += "&roomName=" + this.query.roomName;
				}
				
				this.axios.get(url).then(response => {
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			statusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "冻结";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
			showUpdate(item) {
				this.update.dialog = true;
				this.update.classroom.id = item.id;
				this.update.classroom.shopId = item.shopId;
				this.update.classroom.roomName = item.roomName;
			},
			submitUpdateClassroom() {

				if (!this.update.classroom.shopId) {
					this.$noty.error('校区不能为空');
					return
				}
				if (!this.update.classroom.roomName) {
					this.$noty.error('教室名称不能为空');
					return
				}
	
				// api
				const that = this;
				let url = `/edu/classroom/update`;
			
				// parameters
				const updateData = {
					...this.update.classroom
				}
				
				this.axios.post(url, updateData).catch(() => {
						that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							that.update.dialog = false;
							that.getTableDataList();
							
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				});
			},
			frozenClassroom(item){
				//冻结
				const that = this;
				let url = `/edu/classroom/frozen/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				});
			},
			freeClassroom(item){
				//冻结
				const that = this;
				let url = `/edu/classroom/free/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}				
				});
			},
		}
	}
</script>
<style>
</style>
<style lang="scss" scoped src="../../../assets/styles/management.scss"></style>
